
import { z } from 'zod';
import { SafeStringSchema } from '../types/CommonSchemas';

export const AstraAdminSubscriptionSchema = z.object({
  id: SafeStringSchema,
  modemId: SafeStringSchema,
  isActive: z.boolean(),
  timeCreate: z.iso.datetime(),
  email: SafeStringSchema,
  timeDeactivation: z.iso.datetime(),
  code: SafeStringSchema,
  isRotten: z.boolean()
});

export type AstraAdminSubscriptionData = z.infer<typeof AstraAdminSubscriptionSchema>;

export const AstraAdminSubscriptionListSchema = z.array(AstraAdminSubscriptionSchema);

export type AstraAdminSubscriptionDataList = z.infer<typeof AstraAdminSubscriptionListSchema>;

export const AstraAdminSubscriptionCountSchema = z.object({
  all: z.int(),
  active: z.int()
});

export type AstraAdminSubscriptionCountData = z.infer<typeof AstraAdminSubscriptionCountSchema>;

export interface AstraAdminSubscriptionProlongationRequestData {
  imei: string;
  days: number;
}
